export default {
  path: '/servico-at/:id',
  component: () => import('@/components/pages/ATServices/ATService')
}
